import { render, staticRenderFns } from "./GeneralTableMaterial.vue?vue&type=template&id=de2b70ca&scoped=true&"
import script from "./GeneralTableMaterial.vue?vue&type=script&lang=js&"
export * from "./GeneralTableMaterial.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTableMaterial.vue?vue&type=style&index=0&id=de2b70ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2b70ca",
  null
  
)

export default component.exports